import { Helmet } from "react-helmet-async";
import HeroSection from "../HeroSection/HeroSection";
import CountUp from "../common/CountUp";
import Reveal from "../common/Reveal";
import HomeOffers from "../HomeDetailSection/HomeOffers";
import HomeDetailSection from "../HomeDetailSection/HomeDetailSection";
import HomeUpdateSection from "../HomeDetailSection/HomeUpdateSection";
import InfraShowcase3D, { FACILITY_STATS } from "../DataCenters/InfraShowcase3D";
import BrandPartners from "../company/BrandPartners/BrandPartners";
import ContactSection from "../ContactSection/ContactSection";

const Home = () => {

  return (
    <>
      <Helmet>
        <title>QuantaRock - Data Center, Colocation &amp; Cloud Hosting</title>
        <meta
          name="description"
          content="India's leading data center provider: colocation, dedicated servers, and cloud hosting with 99.99% uptime and 24/7 support."
        />
        <meta
          name="keywords"
          content="data center quantarock, quantarock data centers, quantarock systems, data center india, colocation services, dedicated servers, cloud hosting, IT infrastructure, enterprise hosting, secure data center, managed hosting, quantarock indore, quantarock bangalore, data center solutions"
        />
        <meta name="robots" content="index,follow" />
        <meta
          property="og:title"
          content="QuantaRock - Premium Data Center Solutions & Cloud Hosting"
        />
        <meta
          property="og:description"
          content="Enterprise-grade data centers across India with colocation, dedicated servers, and cloud hosting solutions. 99.99% uptime SLA."
        />
        <meta property="og:url" content="https://quantarock.in/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://quantarock.in/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://quantarock.in/og-image.jpg" />
        <meta
          name="twitter:title"
          content="QuantaRock - Data Center & Cloud Hosting Solutions"
        />
        <meta
          name="twitter:description"
          content="Premium data center colocation and cloud hosting services across India."
        />
        <link rel="canonical" href="https://quantarock.in/" />
        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "QuantaRock Systems",
          url: "https://quantarock.in",
          logo: "https://quantarock.in/assets/LogoMain.png",
          description:
            "Leading data center and IT infrastructure provider offering premium colocation, dedicated servers, cloud hosting, and enterprise IT solutions across 19 Indian cities.",
          address: {
            "@type": "PostalAddress",
            streetAddress: "444, Shyam Nagar(main)",
            addressLocality: "Sukhliya Indore",
            addressRegion: "Madhya Pradesh",
            postalCode: "452010",
            addressCountry: "India",
          },
          telephone: "+91-9755010858",
          email: "info@quantarock.in",
          sameAs: [
            "https://www.facebook.com/profile.php?id=61550422080802",
            "https://x.com/QuantaRock",
            "https://linkedin.com/company/quantarock",
            "https://www.youtube.com/@Quantarock",
          ],
          offers: [
            {
              "@type": "Offer",
              name: "Data Center Colocation",
              description:
                "Premium colocation services with 99.99% uptime guarantee across 19 Indian cities",
            },
            {
              "@type": "Offer",
              name: "Dedicated Servers",
              description:
                "High-performance dedicated server hosting solutions",
            },
            {
              "@type": "Offer",
              name: "Cloud Hosting",
              description: "Scalable cloud hosting and management services",
            },
            {
              "@type": "Offer",
              name: "Disaster Recovery",
              description:
                "Comprehensive disaster recovery and business continuity solutions",
            },
          ],
          knowsAbout: [
            "Data Center Management",
            "Cloud Infrastructure",
            "Network Security",
            "Business Continuity",
            "IT Compliance",
          ],
        })}
        </script>
      </Helmet>
      <HomeOffers />
      <HeroSection />
      <section className="border-t-2 border-[var(--website-secondary-color)] bg-slate-50 py-9">
        <div className="mx-auto grid max-w-6xl grid-cols-2 gap-4 px-6 text-center md:grid-cols-4 md:px-12">
          <Reveal delay={0} className="h-full">
            <div className="group flex h-full flex-col justify-center rounded-2xl border border-transparent p-4 transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.5)] hover:bg-white hover:shadow-md">
              <p className="text-3xl font-bold text-[var(--website-primary-color)] transition group-hover:text-[#0b5e46] md:text-4xl">
                <CountUp end={19} suffix="+" />
              </p>
              <p className="mt-2 text-xs uppercase tracking-[0.18em] text-slate-500">
                Cities across India
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="h-full">
            <div className="group flex h-full flex-col justify-center rounded-2xl border border-transparent p-4 transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.5)] hover:bg-white hover:shadow-md">
              <p className="text-3xl font-bold text-[var(--website-primary-color)] transition group-hover:text-[#0b5e46] md:text-4xl">
                <CountUp end={99.99} decimals={2} suffix="%" />
              </p>
              <p className="mt-2 text-xs uppercase tracking-[0.18em] text-slate-500">
                Uptime SLA
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2} className="h-full">
            <div className="group flex h-full flex-col justify-center rounded-2xl border border-transparent p-4 transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.5)] hover:bg-white hover:shadow-md">
              <p className="text-3xl font-bold text-[var(--website-primary-color)] transition group-hover:text-[#0b5e46] md:text-4xl">24/7</p>
              <p className="mt-2 text-xs uppercase tracking-[0.18em] text-slate-500">
                Expert support
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.3} className="h-full">
            <div className="group flex h-full flex-col justify-center rounded-2xl border border-transparent p-4 transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.5)] hover:bg-white hover:shadow-md">
              <p className="text-3xl font-bold text-[var(--website-primary-color)] transition group-hover:text-[#0b5e46] md:text-4xl">ISO</p>
              <p className="mt-2 text-xs uppercase tracking-[0.18em] text-slate-500">
                27001 &amp; 9001 certified
              </p>
            </div>
          </Reveal>
        </div>
      </section>
      {/* One continuous dark band: why-us → live infrastructure → updates.
          The texture and glows live here so the three blocks read as a single
          surface instead of three stacked sections with repeating decoration. */}
      <div className="relative overflow-hidden bg-[var(--surface-dark)] text-white">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "radial-gradient(circle, #ffffff 1px, transparent 1px)",
            backgroundSize: "26px 26px",
          }}
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -left-32 -top-24 h-[34rem] w-[34rem] rounded-full bg-[rgba(var(--website-secondary-rgb),0.1)] blur-3xl animate-[float-slow_14s_ease-in-out_infinite]"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-32 top-1/3 h-[34rem] w-[34rem] rounded-full bg-indigo-500/10 blur-3xl animate-[float-slow_18s_ease-in-out_infinite_reverse]"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -left-24 bottom-0 h-96 w-96 rounded-full bg-[rgba(var(--website-secondary-rgb),0.1)] blur-3xl animate-[float-slow_16s_ease-in-out_infinite]"
        />

        <section className="relative py-20">
          <div className="relative max-w-6xl mx-auto px-6 md:px-12">
            <div className="text-center mb-12">
              <p className="text-sm uppercase tracking-[0.24em] text-[var(--website-secondary-color)] mb-3">
                Why enterprises choose QuantaRock
              </p>
              <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
                Infrastructure built for reliability, compliance, and long-term growth.
              </h2>
            </div>
            <div className="grid gap-8 lg:grid-cols-3">
            <Reveal delay={0} className="h-full">
              <div className="h-full rounded-3xl border border-white/10 bg-white/5 p-8 transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.4)] hover:bg-white/10">
                <h3 className="text-xl font-semibold mb-4">Pan-India coverage</h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Premium colocation and hosting across 19 cities, with local support, scalable capacity, and enterprise uptime guarantees.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.15} className="h-full">
              <div className="h-full rounded-3xl border border-white/10 bg-white/5 p-8 transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.4)] hover:bg-white/10">
                <h3 className="text-xl font-semibold mb-4">Regulatory readiness</h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Designed for compliance-heavy workloads with physical security, fire protection, access control, and audit-ready operations.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.3} className="h-full">
              <div className="h-full rounded-3xl border border-white/10 bg-white/5 p-8 transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.4)] hover:bg-white/10">
                <h3 className="text-xl font-semibold mb-4">24/7 technical support</h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Expert engineering support, custom solution planning, and vendor-neutral guidance to reduce risk and operational overhead.
                </p>
              </div>
            </Reveal>
            </div>
          </div>
        </section>

        <InfraShowcase3D stats={FACILITY_STATS} seamless />
        <HomeUpdateSection seamless />
      </div>
      <HomeDetailSection />
      <BrandPartners />
      <ContactSection />
    </>
  );
};

export default Home;
